/** Layouts del menú público (plan Menú+). Independiente de `menu_theme`. */

export const MENU_LAYOUT_CLASSIC = 'classic';
export const MENU_LAYOUT_GRID = 'grid';
export const MENU_LAYOUT_LIST = 'list';
export const MENU_LAYOUT_CATEGORIES = 'categories';

export const MENU_LAYOUTS = [
  MENU_LAYOUT_CLASSIC,
  MENU_LAYOUT_GRID,
  MENU_LAYOUT_LIST,
  MENU_LAYOUT_CATEGORIES,
];

export const MENU_LAYOUT_OPTIONS = [
  {
    id: MENU_LAYOUT_CLASSIC,
    name: 'Clásico SoluQR',
    blurb: 'Chips arriba y tarjetas con foto grande. Como hoy.',
  },
  {
    id: MENU_LAYOUT_GRID,
    name: 'Grilla',
    blurb: 'Dos columnas con foto circular. Ideal si tenés buenas fotos.',
  },
  {
    id: MENU_LAYOUT_LIST,
    name: 'Lista',
    blurb: 'Una columna: foto al lado, más detalle por plato.',
  },
  {
    id: MENU_LAYOUT_CATEGORIES,
    name: 'Categorías',
    blurb: 'Primero elegís la sección; después ves los platos.',
  },
];

/**
 * @param {object | null | undefined} business
 * @returns {'classic' | 'grid' | 'list' | 'categories'}
 */
export function getMenuLayout(business) {
  const raw = String(business?.menu_layout ?? MENU_LAYOUT_CLASSIC)
    .trim()
    .toLowerCase();
  if (MENU_LAYOUTS.includes(raw)) return raw;
  return MENU_LAYOUT_CLASSIC;
}

export function normalizeMenuLayoutFromApi(v) {
  return getMenuLayout({ menu_layout: v });
}

export function isCategoryLandingLayout(business) {
  return getMenuLayout(business) === MENU_LAYOUT_CATEGORIES;
}
